import {
  pgTable,
  text,
  serial,
  timestamp,
  integer,
  numeric,
  boolean,
} from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";
import { usersTable } from "./users";

export const dealsTable = pgTable("deals", {
  id: serial("id").primaryKey(),
  title: text("title").notNull(),
  area: text("area").notNull(),
  building: text("building"),
  unitType: text("unit_type"),
  bedrooms: integer("bedrooms"),
  bathrooms: integer("bathrooms"),
  sizeSqft: numeric("size_sqft"),
  askingPrice: numeric("asking_price").notNull(),
  estimatedMarketPrice: numeric("estimated_market_price").notNull(),
  discountPercentage: numeric("discount_percentage"),
  roiYield: numeric("roi_yield"),
  urgencyScore: integer("urgency_score"),
  urgencyReason: text("urgency_reason"),
  sellerTimeline: text("seller_timeline"),
  propertyStatus: text("property_status"),
  paymentPlanDetails: text("payment_plan_details"),
  brokerContact: text("broker_contact"),
  imageUrl: text("image_url"),
  imageUrls: text("image_urls"),
  documentUrls: text("document_urls"),
  developer: text("developer"),
  handoverStatus: text("handover_status"),
  sellerType: text("seller_type", {
    enum: ["owner", "broker", "developer", "distressed_seller"],
  }),
  dealCategory: text("deal_category", {
    enum: ["off_market", "distress_deal", "auction", "exclusive", "investor_only"],
  }),
  description: text("description"),
  visibility: text("visibility", {
    enum: ["investors_only", "brokers_only", "both"],
  })
    .notNull()
    .default("both"),
  submittedByUserId: integer("submitted_by_user_id").references(() => usersTable.id),
  status: text("status", { enum: ["draft", "pending", "approved", "rejected"] })
    .notNull()
    .default("pending"),
  isVipOnly: boolean("is_vip_only").notNull().default(false),
  // AI analysis fields
  aiDistressScore: integer("ai_distress_score"),
  aiDealScore: integer("ai_deal_score"),
  aiInvestorAppeal: text("ai_investor_appeal"),
  aiRiskLevel: text("ai_risk_level"),
  aiRecommendedAction: text("ai_recommended_action"),
  aiInvestorSummary: text("ai_investor_summary"),
  aiRiskFlags: text("ai_risk_flags"),
  aiRecommendedBuyerType: text("ai_recommended_buyer_type"),
  aiLiquidityRating: text("ai_liquidity_rating"),
  aiNegotiationAngle: text("ai_negotiation_angle"),
  aiMissingInfo: text("ai_missing_info"),
  aiPricingComment: text("ai_pricing_comment"),
  aiAdminDecision: text("ai_admin_decision"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});

export const insertDealSchema = createInsertSchema(dealsTable).omit({ id: true, createdAt: true });
export type InsertDeal = z.infer<typeof insertDealSchema>;
export type Deal = typeof dealsTable.$inferSelect;
